import type { SupportedLocale } from "#/lib/locale";

export function resolveChartTimezone(locale: SupportedLocale): string {
	if (locale === "ko") return "Asia/Seoul";
	if (locale === "zh") return "Asia/Shanghai";
	return Intl.DateTimeFormat().resolvedOptions().timeZone || "Etc/UTC";
}
